<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Vue from 'vue';
import { Lazyload } from 'vant';

Vue.use(Lazyload);

export default {
  created() {
    this.initBrand();
    this.getCityGeolocation();
  },
  mounted() {
    const shareData = {
      title: '2020广州国际车展',
      desc: '逛线上车展领现金红包+百万购车福利',
      link: `${window.location.origin}${process.env.VUE_APP_BASE_URL}/index`,
      imgUrl: 'https://w-cdn.pangku.com/uploads/alipay/default/2020111710280502782765555251.jpg',
    };
    this.generateShareLink(shareData);
  },
  methods: {
    ...mapActions('brand', ['initBrand']),
    ...mapActions('city', ['getCityGeolocation']),
    ...mapActions('shareLink', ['generateShareLink']),
  },
};
</script>
